import type { IconDefinition, IconDefinitionState } from '../extensions/icon-definition'

export const getResolvedIcon = (icon: IconDefinition, state: IconDefinitionState): string => {
  if (typeof icon === 'string') {
    return icon
  }

  return state.active ? icon.active : icon.inactive
}
